import { ObjectState } from '../../../cross-team-shared/annotation/shared/state/object-state';
import { DynamicTags } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { findInsertPoint } from '../../../cross-team-shared/annotation/shared/utils/keyframe-utils';
import { withInsertedElements } from '../../../shared/misc-utilities/misc-utils';
import {
  AnnotationEntityExternal,
  LocationExternal,
  ObjectExternal,
  ObjectLocationExternal,
  ShapeEntityExternal,
  ShapeLocationEntityExternal,
  SubmissionMetadata,
} from '../../../team-apis/otterdam/annotations';

export function isObjectEntity(
  annotation: AnnotationEntityExternal,
): annotation is ObjectExternal {
  return annotation.itemType === 'object';
}

export function isObjectLocationEntity(
  annotation: AnnotationEntityExternal,
): annotation is ObjectLocationExternal {
  return annotation.itemType === 'object_location';
}

export function isObjectRelatedEntity(
  annotation: AnnotationEntityExternal,
): annotation is ObjectExternal | ObjectLocationExternal {
  return isObjectEntity(annotation) || isObjectLocationEntity(annotation);
}

export function isShapeEntity(
  annotation: AnnotationEntityExternal,
): annotation is ShapeEntityExternal {
  return annotation.itemType === 'shape';
}

export function isShapeLocationEntity(
  annotation: AnnotationEntityExternal,
): annotation is ShapeLocationEntityExternal {
  return annotation.itemType === 'location';
}

export function isShapeRelatedEntity(
  annotation: AnnotationEntityExternal,
): annotation is ShapeEntityExternal | ShapeLocationEntityExternal {
  return isShapeEntity(annotation) || isShapeLocationEntity(annotation);
}

export function isSubmissionMetadata(
  annotation: AnnotationEntityExternal,
): annotation is SubmissionMetadata {
  return annotation.itemType === 'submission_metadata';
}

export function appendDynamicTag(
  { frameNumber, tags }: LocationExternal,
  dynamicTags: DynamicTags,
) {
  const updatedDynamicTags = { ...dynamicTags };
  Object.entries(tags ?? {}).forEach(([key, value]) => {
    // new key to be added to the dynamic tags
    const existingTags = dynamicTags[key] ?? [];
    const insertPoint = findInsertPoint(existingTags, frameNumber);

    updatedDynamicTags[key] = withInsertedElements(existingTags, insertPoint, {
      frame_number: frameNumber,
      value,
    });
  });
  return updatedDynamicTags;
}

export function convertObjectExternalToObjectInternal(
  objectExternal: ObjectExternal,
): ObjectState {
  return {
    class: objectExternal.className,
    tags: objectExternal.tags || {},
    index: objectExternal.objectId,
    sortIndex: objectExternal.sortIndex,
    parentId: objectExternal.parentId,
    dynamic_tags: {},
    childObjectIds: [],
    childShapeIds: [],
  };
}

export function getObjects(annotations: AnnotationEntityExternal[]) {
  return annotations.filter(isObjectEntity);
}
